import React from "react";
import { Autocomplete, TextField, Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  autocomplete: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      border: "2px solid #D0D5DD",
      borderRadius: "4px",
      "&:hover": {
        borderColor: "#98A2B3",
      },
      "&.Mui-focused": {
        borderColor: theme.palette.primary.main,
      },
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "1rem",
      color: "rgba(0, 0, 0, 0.87)",
      "&::placeholder": {
        color: "#A4A6A8",
        opacity: 1,
      },
    },
  },
  option: {
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    minHeight: "50px",
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  paper: {
    maxHeight: "300px",
    width: "100%",
    minWidth: "400px",
    maxWidth: "95vw",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
}));

export default function BranchSelectComponent({
  selectedBranch,
  placeholder,
  branchDropdown,
  isFetching,
  handleBranchChange,
  isError,
  disabled,
}) {
  const classes = useStyle();

  return (
    <Autocomplete
      value={selectedBranch}
      onChange={(event, newValue) => {
        handleBranchChange(newValue);
      }}
      options={branchDropdown || []}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      loading={isFetching}
      loadingText="Loading branches..."
      noOptionsText={isError ? "Error loading branches" : "No branches found"}
      disabled={disabled}
      disablePortal
      className={classes.autocomplete}
      PaperComponent={({ children, ...props }) => (
        <Box {...props} className={classes.paper}>
          {children}
        </Box>
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} className={classes.option}>
          <Typography
            variant="body1"
            style={{ fontWeight: 500, fontSize: "1rem" }}
          >
            {option.name}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={placeholder || "Select a branch..."}
          fullWidth
        />
      )}
    />
  );
}
